import Layout from "../UI/Layout/Layout";
import CareerHero from "./CareerHero";
import CareerBoxes from "./CareerBoxes";
import CareerReasons from "./CareerReasons";
import CareerContact from "./CareerContact";
import CareerOpenPositions from "./CareerOpenPositions";

const Career = () => {
  return (
    <Layout authLevelRequired={false}>
      <div className="pb-32">
        <CareerHero />
        <CareerBoxes />
        <CareerReasons />
        <CareerContact />
        <CareerOpenPositions />
      </div>
    </Layout>
  );
};

export default Career;
